/**
 * Shop Subpage Filter & Sort functionality.
 * 
 */

/**
 * Mobile:
 * Desktop:
 */

let
	$myFilterBtn = $('.filter-sort-button.filter'),
	$myFilterPanel = $('.filter-panel'),
	$filterNum = $('.filter-num'),
	myBrand = '',
	myCategories = [],
	myConcern = '',
	// myAppliedFilters = ['',[],''];	// Save currently applied filters as brand string, array of category strings, concern string.
	myAppliedFilters = [],	// Save currently applied filters as array of strings.
	myFilterNum = 0;

// Populate and pre-select filter menu based on query vars.
function setFilters() {
	console.log("FILTERS: setFilters()");
	var urlParams;
	(window.onpopstate = function () {
	    var match,
	        pl     = /\+/g,  // Regex for replacing addition symbol with a space
	        search = /([^&=]+)=?([^&]*)/g,
	        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
	        query  = window.location.search.substring(1);
	  
	    urlParams = {};
	    while (match = search.exec(query))
	       urlParams[decode(match[1])] = decode(match[2]);
	})();

	if (!jQuery.isEmptyObject(urlParams)) {
		// Create array of selected filter slugs.
		var activeFilters = urlParams['filter'].split(',');
		
		// Set applied filters = selected filters.
		// Code in initFilters() will update filters panel accordingly.
		myAppliedFilters = activeFilters;

		// Update number of filters value and rendered number.
		myFilterNum = activeFilters.length;
		$filterNum.text('('+myFilterNum+')');

		// Populate myBrand, myCategories, myConcern based on query vars.
		myCategories = [];
		if (activeFilters.length > 0) {
			$.each(activeFilters, function(index, myFilter) {
				if (myFilter.includes('type-')) {
					myCategories.push(myFilter);
				} else if (myFilter.includes('concern')) {
					myConcern = myFilter;
				} else {
					myBrand = myFilter;
				}
			});
		}

		// Create var of selected sort option.
		// var activeSort = urlParams['sort'].split(',');

		// Set applied sort = selected sort.

	}
}

function initFilters() {
	console.log("FILTERS: initFilters()");
	let
		$allFilters = $('.filter-panel__group .filter-panel__filter-link'),
		$brandFilters = $('.filter-panel__group:nth-child(1) .filter-panel__filter-link'),
		$categoryFilters = $('.filter-panel__group:nth-child(2) .filter-panel__filter-link'),
		$concernFilters = $('.filter-panel__group:nth-child(3) .filter-panel__filter-link'),
		$btnApply = $('.filter-panel__button.apply'),
		$btnReset = $('.filter-panel__button.reset');

	// Expand/collapse filter panel on "Show Filters"/"Hide Filters" click.
	$myFilterBtn.on('click',function(evt) {
		evt.preventDefault();
		if ($(this).hasClass('expanded')) {
			// If filter panel is open...
			// Close panel.
			$(this).removeClass('expanded');
			$myFilterPanel.slideUp(300);
			// Ignore not-applied filters.
			myFilterNum = myAppliedFilters.length;
			$filterNum.text('('+myFilterNum+')');
			console.log('CLOSE PANEL: '+myAppliedFilters);
		} else {
			// If filter panel is closed...
			// If sort panel is open...
			// if ($mySortBtn.hasClass('expanded')) {	// Obsolete if using ShopWP Sort.
			// 	// Close sort panel.
			// 	$mySortBtn.removeClass('expanded');
			// 	$mySortbyPanel.slideUp(300);
			// }
			// Open panel.
			$(this).addClass('expanded');
			$myFilterPanel.slideDown(300);
			// Set all filters to unselected.
			$allFilters.removeClass('active');
			// Set applied filters to selected.
			myAppliedFilters.forEach(function(item) {
				console.log('item: '+item);
				$allFilters.filter('[data-filter="'+item+'"]').addClass('active');
			});

			var handler = function(event){
				console.log("CLICK OFF");
				// if the target is a descendent of container do nothing
				if($(event.target).is('.filter-sort-button.filter, .filter-sort-button.filter *, .filter-panel, .filter-panel *')) return;
				
				// remove event handler from document
				$(document).off("click", handler);
				
				// Close panel.
				$myFilterBtn.removeClass('expanded');
				$myFilterPanel.slideUp(300);
				// Ignore not-applied filters.
				myFilterNum = myAppliedFilters.length;
				$filterNum.text('('+myFilterNum+')');
			};
			
			$(document).on("click", handler);

			console.log('OPEN PANEL: '+myAppliedFilters);
		}
	});

	// [ APPLY FILTERS ]
	$btnApply.on('click',function(event) {
		console.log('FILTER: APPLY');
		event.preventDefault();
		$myFilterBtn.removeClass('expanded');
		$myFilterPanel.slideUp(300);
		myAppliedFilters = [];
		// Save selected filters (now applied).
		if (myBrand != '') {
			if (!myAppliedFilters.includes(myBrand)) myAppliedFilters.push(myBrand);
		}
		if (myConcern != '') {
			if (!myAppliedFilters.includes(myConcern)) myAppliedFilters.push(myConcern);
		}
		myCategories.forEach(function(item, index) {
			if (item != '') {
				if (!myAppliedFilters.includes(item)) myAppliedFilters.push(item);
				$categoryFilters.find('[data-filter="'+item+'"]').addClass('active');
			}
		});
		var currentUrl = window.location.href;
		console.log('FILTER: currentUrl: '+currentUrl);
		var currUrlLastPos = currentUrl.length - 1;
		if(currentUrl.lastIndexOf('/') != currUrlLastPos) {
			currentUrl = currentUrl.substring(0, currentUrl.lastIndexOf('/')+1);
		}
		if (myAppliedFilters.length > 0) {
			var params = (myAppliedFilters.join(","));
			// var new_filter_url = window.location.href.split('?')[0] + '?filter=' + params;
			var new_filter_url = currentUrl + '?filter=' + params;
		} else {
			// new_filter_url = window.location.href.split('?')[0];
			new_filter_url = currentUrl;
		}
		console.log('FILTER: currentUrl: '+currentUrl);
		console.log('FILTER: new_filter_url: '+new_filter_url);
		window.location.href = new_filter_url;
	});

	// [ RESET ALL ]
	$btnReset.on('click',function() {
		myBrand = '';
		myCategories = [];
		myConcern = '';
		$brandFilters.removeClass('active');
		$categoryFilters.removeClass('active');
		$concernFilters.removeClass('active');
		myFilterNum = 0;
		myAppliedFilters = [];
		$filterNum.text('('+myFilterNum+')');
	});

	// Brand filters. Select one max.
	$brandFilters.on('click',function(evt) {
		evt.preventDefault();
		var $myLink = $(this);
		if ($myLink.hasClass('active')) {
			$myLink.removeClass('active');
			myBrand = '';
			myFilterNum--;
		} else {
			if ($brandFilters.hasClass('active')) {
				$brandFilters.removeClass('active');
				myFilterNum--;
			}
			$myLink.addClass('active');
			myBrand = $myLink.data('filter');
			myFilterNum++;
		}
		$filterNum.text('('+myFilterNum+')');
		console.log('FILTER: Brand: '+myBrand);
	});

	// Category filters. Select multiple.
	$categoryFilters.on('click',function(evt) {
		evt.preventDefault();
		var $myLink = $(this);
		if ($myLink.hasClass('active')) {
		// If selected, deselect.
			$myLink.removeClass('active');
			myCategories.splice($.inArray($myLink.data('filter'), myCategories), 1);
			myFilterNum--;
		} else {
		// If not selected, select.
			$myLink.addClass('active');
			myCategories.push($myLink.data('filter'));
			myFilterNum++;
		}
		$filterNum.text('('+myFilterNum+')');
		console.log('FILTER: Categories: '+myCategories);
	});

	// Concern filters. Select one max.
	$concernFilters.on('click',function(evt) {
		evt.preventDefault();
		var $myLink = $(this);
		if ($myLink.hasClass('active')) {
			$myLink.removeClass('active');
			myConcern = '';
			myFilterNum--;
		} else {
			if ($concernFilters.hasClass('active')) {
				$concernFilters.removeClass('active');
				myFilterNum--;
			}
			$myLink.addClass('active');
			myConcern = $myLink.data('filter');
			myFilterNum++;
		}
		$filterNum.text('('+myFilterNum+')');
		console.log('FILTER: Concern: '+myConcern);
	});
}

// let
// 	$mySortBtn = $('.filter-sort-button.sortby'),
// 	$mySortbyPanel = $('.product-sortby__panel');

// function initSort() {
// 	console.log("FILTERS: initSort()");

// 	$mySortBtn.on('click',function(evt) {
// 		// If filter panel is open...
// 		if ($myFilterBtn.hasClass('expanded')) {
// 			// Close filter panel.
// 			$myFilterBtn.removeClass('expanded');
// 			$myFilterPanel.slideUp(300);
// 			// Ignore not-applied filters.
// 			myFilterNum = myAppliedFilters.length;
// 			$filterNum.text('('+myFilterNum+')');
// 		}
// 	});
// }

let
	sortBtnClicked = false,
	myAppliedSort = '';	// Save currently applied sort as string.

// Initialize ShopWP Sort menu with highlighted default sort option (title).
function initShopWpSortMenu() {
	console.log("SORT: initShopWpSort()");	
	let 
		$myShopWpSortBtn = $('button.szh-menu-button');
	console.log("SORT: $initShopWpSortMenu: "+$myShopWpSortBtn.attr("class"));

	function highlightSelectedOption() {
		console.log("SORT: highlightSelectedOption()");
		var $mySelectedOption = $('.swp-select-item li[label="TITLE"]');
		console.log("SORT: $mySelectedOption: "+$mySelectedOption.attr("label"));
		console.log("SORT: $mySelectedOption parent: "+$mySelectedOption.parent().attr("class"));
		$mySelectedOption.parent().attr('data-is-selected', true);
	}

	$myShopWpSortBtn.on('click', function(evt) {
		// On first click, assign selected state to selected option".
		// Delayed because of ShopWP load.
		if (!sortBtnClicked) {
			sortBtnClicked = true;
			setTimeout(highlightSelectedOption, 100);
		}
	});
}

// Initialize ShopWP Sort button (opens menu) and Sort Options.
function initShopWpSort() {
	console.log("SORT: initShopWpSort()");	
	let 
		$myShopWpSortBtn = $('button.szh-menu-button');
	console.log("SORT: $myShopWpSortBtn: "+$myShopWpSortBtn.attr("class"));

	// ShopWP Sort options.
	function initShopWpOptions() {
		console.log('SORT: initShopWpOptions()');
		let 
			$myShopWpSortOptions = $('.swp-select-item');	// Only available after load.

		$myShopWpSortOptions.on('click', function(evt) {
			// var myAppliedSort = $(this).find('li').text();
			myAppliedSort = $(this).find('li').attr('label');
			myAppliedSort = myAppliedSort.toLowerCase();
			console.log('SORT: myAppliedSort: '+myAppliedSort);
			var paramsFilters = (myAppliedFilters.join(","));
			var paramsSort = myAppliedSort;
			var queryString = '?';
			if (myAppliedFilters.length > 0) {
				queryString += 'filter=' + paramsFilters + '&';
			}
			queryString += 'sort=' + paramsSort;
			var new_filter_url = window.location.href.split('?')[0] + queryString;
			// console.log("new_filter_url: "+new_filter_url);
			window.location.href = new_filter_url;
		});
	}

	// ShopWP Sort menu trigger.
	$myShopWpSortBtn.on('click', function(evt) {
		// On first click, assign click handlers to Sort options.
		// Delayed because of ShopWP load.
		if (!sortBtnClicked) {
			sortBtnClicked = true;
			setTimeout(initShopWpOptions, 100);
		}
	});
}

exports.init = function () {
	console.log('FILTER/SORTBY: exports.init');
	// Run init methods...

	initFilters();
	setFilters();
	// setTimeout(initShopWpSortMenu, 2000);	// This needs to be called after ShopWP is loaded!
	// setTimeout(initShopWpSort, 2000);	// This needs to be called after ShopWP is loaded!
	// initShopWpSort();
};